import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Result } from '@app/models/common/result';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { User } from '@app/models/settings/user';
import { UserPwd } from '@app/models/user-pwd';
import { Contract } from '@app/models/settings/contract';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private http: HttpClient) {}

  getUserProfile(): Observable<User> {
    const url = `${environment.apiUrl}/user/profile/info`;
    return this.http.get<Result<User>>(url).pipe(map(res => res.data));
  }

  updateSelfProfile(payload: User): Observable<boolean> {
    const url = `${environment.apiUrl}/user/profile/update`;
    return this.http.post<Result<boolean>>(url, payload).pipe(map(res => res.data));
  }

  updateSelfPassword(payload: UserPwd): Observable<boolean> {
    const url = `${environment.apiUrl}/user/profile/updatePwd`;
    return this.http.post<Result<boolean>>(url, payload).pipe(map(res => res.data));
  }

  switchInsightPush(): Observable<boolean> {
    const url = `${environment.apiUrl}/incentive/switchPush`;
    return this.http.post<Result<boolean>>(url, null).pipe(map(res => res.data));
  }

  getUserContracts(): Observable<Contract[]> {
    const url = `${environment.apiUrl}/user/contracts`;
    return this.http.get<Result<Contract[]>>(url).pipe(map(res => res.data));
  }

  switchContract(contractId: number): Observable<boolean> {
    const url = `${environment.apiUrl}/user/contract/${contractId}/switch`;
    return this.http.post<Result<boolean>>(url, null).pipe(map(res => res.data));
  }
}
